module.exports = __webpack_public_path__ + "static/media/hold.dec14a51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Others/hold.svg
// module id = 1826
// module chunks = 0